varying vec2 vUv; 
varying vec3 vPos; 
varying vec3 vNormal; 
#define PI 3.1415926538
uniform float u_time;
uniform float u_amplitude;
uniform float u_idea;

void main(){

    vec3 newPos = position; 
    // float angle = atan(newPos.z, newPos.x);
    // newPos += cos(angle);
float angle = atan(newPos.x, newPos.z);
angle += 0.5 * PI;

// Normaliser pour rester dans [-PI, PI]
if (angle > PI) {
    angle -= 2.0 * PI;
}


    float maskHeight = (1.-newPos.y-1.)*3.;
    maskHeight = clamp(maskHeight, 0., 1.);
    maskHeight *=abs(angle)/PI*0.5;
   maskHeight *=1.-(abs(angle)/PI);
    float displacement = angle < 0. ? cos(angle*10.+u_time)*(maskHeight) : cos(angle*10.-u_time)*(maskHeight);

    newPos.y += displacement*u_amplitude;

    vec3 wavePos = vec3(0., u_idea, 0.);
    float dist = distance(newPos, wavePos);
    float influence = 1.0 - smoothstep(0.0, 1., dist);
    newPos += normal * influence * 0.2;
    
    vec4 modelPosition = modelMatrix * vec4(newPos, 1.0);



    vec4 viewPosition =  viewMatrix * modelPosition;
    vec4 projectedPosition = projectionMatrix * viewPosition;
    gl_Position = projectedPosition;


    // aditionnal calculations
    vUv = uv;
    vPos = position;
    vNormal = (modelMatrix * vec4(normal, 0.0)).xyz;
    // vNormal = normal;

}